import { render } from "./ReservationTab.vue?vue&type=template&id=312e0b51"
import script from "./ReservationTab.vue?vue&type=script&lang=js"
export * from "./ReservationTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__